export const tabs = [
  { id: "1", title: "Project Overview" },
  { id: "2", title: "Design" },
  { id: "3", title: "Rooms" },
  { id: "4", title: "BOQ" },
  { id: "5", title: "Scopes" },
  { id: "6", title: "Schedule" },
  { id: "7", title: "Billing Milestones" },
  { id: "8", title: "Payments" },
  { id: "9", title: "Change Requests" },
  { id: "10", title: "Inspections" },
  { id: "11", title: "Issues" },
  { id: "12", title: "Progress Updates" },
  { id: "13", title: "Workforce Management" },
];
export default tabs;

export const statusStyleArray = [
  {
    status: "draft",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "draft-by-contractor",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "Requested",
    backgroundColor: "#c41d7f",
    color: "#fff0f6",
  },
  {
    status: "awaiting-approval",
    color: "#d4b106",
    backgroundColor: "#feffe6",
  },
  {
    status: "awaiting-contractor-confirmation",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "approved-by-contractor",
    backgroundColor: "#d46b08",
    color: "#fff7e6",
  },
  {
    status: "rejected-by-contractor",
    color: "rgb(229, 71, 70)",
    backgroundColor: "#fff0f6",
  },
  {
    status: "proposed-to-client",
    color: "#fff",
    backgroundColor: "rgb(56, 158, 13)",
  },
  {
    status: "completed",
    color: "#f6ffed",
    backgroundColor: "#2e6f40",
  },
  {
    status: "in_warranty",
    color: "#fff",
    backgroundColor: "#c292fd",
  },
  {
    status: "ongoing",
    backgroundColor: "#096dd9",
    color: "#e6f7ff",
  },
  {
    status: "delivered",
    color: "#389e0d",
    backgroundColor: "#f6ffed",
  },
];

export const milestoneStatusStyleArray = [
  {
    status: "ongoing",
    color: "#096dd9",
    backgroundColor: "#e6f7ff",
  },
  {
    status: "Not Started",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "delivered",
    backgroundColor: "#389e0d",
    color: "#fff",
  },
  {
    status: "pending",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "completed",
    backgroundColor: "rgb(56, 158, 13)",
    color: "#fff",
  },
  {
    status: "in_review",
    color: "rgb(229, 71, 70)",
    backgroundColor: "#fff0f6",
  },
  {
    status: "approved",
    color: "#01ec0b",
    backgroundColor: "#01ec0b",
  },
  {
    status: "change_request",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  { status: "due", backgroundColor: "#d46b08", color: "#fff7e6" },
  { status: "closed", color: "rgb(229, 71, 70)", backgroundColor: "#fff0f6" },
];

export const paymentStatusStyleArray = [
  { status: "due", backgroundColor: "#d46b08", color: "#fff7e6" },
  {
    status: "ongoing",
    color: "#096dd9",
    backgroundColor: "#e6f7ff",
  },
  {
    status: "Created",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "CREATED",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "INITIATED",
    backgroundColor: "#096dd9",
    color: "#e6f7ff",
  },
  {
    status: "completed",
    backgroundColor: "rgb(56, 158, 13)",
    color: "#fff",
  },
  {
    status: "Not Started",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "PAID",
    backgroundColor: "rgb(56, 158, 13)",
    color: "#fff",
  },
  {
    status: "delivered",
    backgroundColor: "#389e0d",
    color: "#fff",
  },
];

export const inspectionStatusStyleArray = [
  //CREATED, REQUESTED, READY_FOR_INSPECTION, SCHEDULED, SUBMITTED
  {
    status: "CREATED",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "REQUESTED",
    backgroundColor: "#c41d7f",
    color: "#fff0f6",
  },
  {
    status: "READY_FOR_INSPECTION",
    color: "#389e0d",
    backgroundColor: "#f6ffed",
  },
  {
    status: "SCHEDULED",
    backgroundColor: "#096dd9",
    color: "#e6f7ff",
  },
  {
    status: "SUBMITTED",
    color: "#f6ffed",
    backgroundColor: "#2e6f40",
  },
  {
    status: "PASS",
    color: "#fff",
    backgroundColor: "rgb(56, 158, 13)",
  },
  {
    status: "FAIL",
    color: "rgb(229, 71, 70)",
    backgroundColor: "#fff0f6",
  },
];

export const inspectionStatusNewStyleArray = [
  //CREATED, REQUESTED, READY_FOR_INSPECTION, SCHEDULED, SUBMITTED
  {
    status: "CREATED",
    backgroundColor: "#d46b08",
  },
  {
    status: "REQUESTED",
    color: "#c41d7f",
  },
  {
    status: "READY_FOR_INSPECTION",
    backgroundColor: "#096dd9",
  },
  {
    status: "SUBMITTED",
    backgroundColor: "#2e6f40",
  },
  {
    status: "PASS",
    color: "#fff",
    backgroundColor: "rgb(56, 158, 13)",
  },
  {
    status: "FAIL",
    color: "rgb(229, 71, 70)",
    backgroundColor: "#fff0f6",
  },
];

export const snagStatusStyleArray = [
  {
    status: "OPEN",
    backgroundColor: "#096dd9",
  },
  {
    status: "RESOLVED",
    backgroundColor: "#4BB34B",
  },
  {
    status: "READY_FOR_INSPECTION",
    backgroundColor: "#d46b08",
  },
  { status: "UNRESOLVED", backgroundColor: "#E54746" },
];

export const changeRequestStatusStyleArray = [
  {
    status: "edited",
    backgroundColor: "#c41d7f",
    color: "#fff0f6",
  },

  {
    status: "added",
    backgroundColor: "#096dd9",
    color: "#e6f7ff",
  },

  {
    status: "deleted",
    backgroundColor: "rgb(229, 71, 70)",
    color: "#fff0f6",
  },
];
